import {
  AlignLeftOutlined,
  CalendarOutlined,
  DollarCircleOutlined,
  DotChartOutlined,
  StarOutlined,
  TrophyOutlined,
} from '@ant-design/icons';
import { SuggestedPriceExplanationCategory } from '@features/suggested-price-column/api/get-suggested-price-explanation';
import { SuggestedPriceIconTile } from '@features/suggested-price-column/components/suggested-price-icon-tile/suggested-price-icon-tile';

/**
 * Glyph per explanation category. Sourced from the component names documented on the Figma
 * design itself, so these are the designer-specified icons rather than a visual guess.
 */
const ICON_BY_CATEGORY = {
  baseline_vs_supplier_pool: DotChartOutlined,
  event_setup: AlignLeftOutlined,
  supplier_competition: TrophyOutlined,
  supplier_pool_experience: StarOutlined,
  supplier_pool_pricing_history: DollarCircleOutlined,
  timing: CalendarOutlined,
} as const;

interface SuggestedPriceCategoryIconProps {
  category: SuggestedPriceExplanationCategory;
}

/**
 * Icon tile for an explanation factor's category. Falls back to the event-setup glyph when the
 * backend sends a category this client predates, so an unknown key degrades to a plain row
 * rather than a missing-component crash.
 */
export const SuggestedPriceCategoryIcon = ({ category }: SuggestedPriceCategoryIconProps) => {
  const Glyph = ICON_BY_CATEGORY[category] ?? ICON_BY_CATEGORY.event_setup;

  return (
    <SuggestedPriceIconTile dataTestId={`suggested-price-category-icon-${category}`}>
      <Glyph />
    </SuggestedPriceIconTile>
  );
};
